// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCXxqqyqnhX01y_yCHBGSd31Dg_kM-J2Xc",
  authDomain: "player-rating-2ba33.firebaseapp.com",
  projectId: "player-rating-2ba33",
  storageBucket: "player-rating-2ba33.firebasestorage.app",
  messagingSenderId: "564345879089",
  appId: "1:564345879089:web:fb832d24f8de78a95ef310"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
